import React from "react";

// Shared button. Variants reuse the existing palette (accent cyan / navy).
const VARIANTS = {
  primary:
    "bg-accent text-navy-900 hover:bg-accent-soft focus-visible:ring-accent shadow-sm",
  secondary:
    "border border-white/15 bg-white/5 text-white hover:bg-white/10 focus-visible:ring-white/30",
  ghost:
    "text-accent hover:bg-white/5 hover:text-accent-soft focus-visible:ring-accent",
};

export default function Button({
  variant = "primary",
  type = "button",
  href,
  className = "",
  children,
  ...props
}) {
  const classes = `inline-flex items-center justify-center gap-2 rounded-xl px-5 py-2.5 text-sm font-semibold tracking-wide transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-navy-900 disabled:cursor-not-allowed disabled:opacity-60 ${VARIANTS[variant]} ${className}`;

  if (href) {
    return (
      <a href={href} className={classes} {...props}>
        {children}
      </a>
    );
  }

  return (
    <button type={type} className={classes} {...props}>
      {children}
    </button>
  );
}
